import { getMaterialComponentLabel, type MaterialComponentValue, type MaterialProductComponentValue } from 'api';
import { Box, Chip, Stack, TypographyIcon } from 'ui';
import { ContentPasteSearchOutlined } from 'ui/icons';

type Props<T extends MaterialComponentValue | MaterialProductComponentValue> = {
  materialComponents: T[];
  title?: string;
  variant?: 'body1' | 'body2';
};

export const MaterialComponentValueList = <T extends MaterialComponentValue | MaterialProductComponentValue>({
  materialComponents,
  title = 'Material components',
  variant = 'body1',
}: Props<T>) => {
  return (
    <Stack direction="column" gap={1}>
      <TypographyIcon icon={ContentPasteSearchOutlined} variant={variant}>
        {title}: {materialComponents.length === 0 ? '-' : ''}
      </TypographyIcon>
      <Box marginLeft={3.5}>
        {materialComponents.map((materialComponent, index) => (
          <Chip
            color="info"
            size="small"
            label={getMaterialComponentLabel(materialComponent)}
            key={index + materialComponent.supported_component.component.name}
          />
        ))}
      </Box>
    </Stack>
  );
};
